<template>
  <HeraConfirm
    v-bind="{
      title,
      text,
      cancelButtonText,
      confirmButtonText,
      isLoading,
    }"
    v-on="$listeners"
  >
    <TournamentSharingSettings
      :social-networks="connectedSocials"
      class="mt-4"
    />
  </HeraConfirm>
</template>

<script>
import { mapActions } from 'vuex';
import HeraConfirm from './HeraConfirm';
import TournamentSharingSettings from '@/views/tournaments/management/singleTournament/components/SharingSettings';
export default {
  name: 'TournamentAnnounceModal',
  components: { HeraConfirm, TournamentSharingSettings },

  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    cancelButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonText: {
      type: [String, Boolean],
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      connectedSocials: [],
    };
  },
  created() {
    this.fetchAccountSocialConnectionStatus()
      .then(connections => {
        if (connections) {
          const platforms = [];
          if (connections.facebookCredentialsDefined) {
            platforms.push('facebook');
          }
          if (connections.twitterCredentialsDefined) {
            platforms.push('twitter');
          }
          this.connectedSocials = platforms;
        }
      })
      .catch(this.errorNotify);
  },
  methods: {
    ...mapActions(['fetchAccountSocialConnectionStatus', 'errorNotify']),
  },
};
</script>
